<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAppleLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M19.264 16.427a9.785 9.785 0 0 1-.968 1.74c-.509.726-.925 1.228-1.247 1.507-.497.458-1.03.692-1.602.706-.41 0-.904-.117-1.48-.354-.577-.235-1.108-.352-1.593-.352-.509 0-1.055.117-1.638.352-.585.237-1.056.36-1.416.372-.548.024-1.094-.217-1.638-.724-.348-.303-.783-.823-1.304-1.56-.56-.787-1.019-1.699-1.38-2.739-.385-1.123-.578-2.21-.578-3.264 0-1.206.26-2.247.783-3.118.41-.7.956-1.253 1.64-1.659a4.41 4.41 0 0 1 2.215-.625c.435 0 1.006.134 1.715.399.707.265 1.16.4 1.36.4.148 0 .652-.158 1.507-.471.808-.291 1.49-.412 2.05-.364 1.514.122 2.652.72 3.408 1.795-1.354.82-2.024 1.97-2.01 3.444.011 1.149.428 2.104 1.247 2.863.371.352.786.625 1.247.818-.1.29-.206.568-.318.834ZM15.79 2.76c0 .9-.33 1.74-.985 2.519-.79.925-1.748 1.46-2.785 1.375A2.807 2.807 0 0 1 12 6.313c0-.865.376-1.79 1.044-2.546a4.02 4.02 0 0 1 1.272-.955c.514-.25 1-.388 1.456-.412.013.12.019.24.019.36Z"
    />
</svg>
